import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import MenuItemT from '@/Controls/MenuItem';

export default class MenuItemsBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.menuItems = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let MenuItem = ComponentManager.getControl<typeof MenuItemT>('MenuItem');

                let menu = $(element);
                let options = valueAccessor();
                let items = options.items;
                let parent = options.parent;
                let widget = options.widget();

                function onItemsChange(items) {
                    menu.find('li').each(function () {
                        widget.remove($(this));
                    });

                    parent.elements = [];

                    for (let i = 0; i < items.length; i++) {
                        let menuRef = widget.append({ text: '' }, menu);
                        let menuItemElem;

                        if (menu.find('.k-group').length > 0) {
                            menuItemElem = menu.find('.k-group .k-item').last();
                        } else {
                            menuItemElem = menu.children('.k-item').last();
                        }

                        let menuItem = new MenuItem(items[i], menuItemElem);
                        let tuple = menuItem.getTuple();

                        parent.elements.push(menuItem);
                    }
                }

                let subscription = items.subscribe(onItemsChange);
                ko.utils.domNodeDisposal.addDisposeCallback(menu[0], () => {
                    subscription.dispose();
                });
                onItemsChange(items());
            }
        };
    }
}